import {Controller} from "@hotwired/stimulus"

export class CounterController extends Controller {
	connect() {
		let paneId = this.element.parentElement.dataset.coreuiTarget
		if (!paneId) return

		this.pane = document.querySelector(paneId)
		if (!this.pane) return

		this.observer = new MutationObserver(() => this.updateCount())
		this.observer.observe(this.pane, {
			childList: true,
			subtree: true,
			attributes: true,
			attributeFilter: ["class"]
		})
	}

	disconnect() {
		this.observer?.disconnect()
	}

	updateCount() {
		const count = this.pane.querySelectorAll(".district-operations:not(.d-none) .operation").length
		if(count === 1) {
			this.element.innerText = count + " Einsatz"
		} else {
			this.element.innerText = count + " Einsätze"
		}
	}
}